import React, { useMemo } from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { MarginOrderDirection, MarginOrderType, ProtectionOrderVariant } from '@swyftx/margin/build/types';
import { MarginPosition } from '@swyftx/margin/build/types';

import { MarginProtectionOrderInput } from '@routes/SwyftxMargin/components/General';

import { useMarginInstruments } from 'src/lib/margin/hooks/instruments';
import { useMarginPositionDetails } from 'src/lib/margin/hooks/positions';

import { useMarginPositionDetailsProtectionOrder } from './useMarginPositionDetailsProtectionOrder';

type Props = {
  position?: MarginPosition;
  protectionOrderType: ProtectionOrderVariant;
  tradeSide: MarginOrderDirection;
  tradeType: MarginOrderType;
  value?: string;
  price?: string;
  checked: boolean;
  placeholder?: string;
  onChange: React.Dispatch<React.SetStateAction<string>>;
  onCheckedChanged: (checked: boolean) => void;
};

const MarginPositionDetailsProtectionOrder: React.FC<Props> = ({
  position,
  protectionOrderType,
  tradeSide,
  tradeType,
  value,
  placeholder,
  checked,
  price,
  onChange,
  onCheckedChanged,
}) => {
  const { getMarketById } = useMarginInstruments();

  const positionMarket = useMemo(() => getMarketById(position?.marketUuid), [getMarketById, position?.marketUuid]);
  const { currentPrice } = useMarginPositionDetails({ positionId: position?.positionId });

  const { title, leadingLabel, formattedAmount, onChangeValue, tabs, onChangeTab, error } =
    useMarginPositionDetailsProtectionOrder({
      tradeSide,
      tradeType,
      protectionOrderType,
      value,
      lots: position?.volume,
      price: position?.opened ? currentPrice?.toString() : price,
      positionMarket,
      onChange,
    });

  return (
    <FlexLayout direction='column' spacing={8}>
      <MarginProtectionOrderInput
        title={title}
        checked={checked}
        onCheckedChange={onCheckedChanged}
        value={formattedAmount}
        onChangeValue={onChangeValue}
        leadingLabel={leadingLabel}
        tabs={tabs}
        placeholder={placeholder}
        onChangeTab={onChangeTab}
        tradeSide={tradeSide}
        protectionOrderType={protectionOrderType}
        error={error}
      />
    </FlexLayout>
  );
};

export { MarginPositionDetailsProtectionOrder };
